import React, { useEffect, useState } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { getSupabaseErrorMessage, loadPublicSettings } from '../data/repository';
interface PrivacyContact {
  email: string;
  phone: string;
}
export function PrivacyPolicy() {
  const [contact, setContact] = useState<PrivacyContact>({
    email: '',
    phone: ''
  });
  const [error, setError] = useState('');
  useEffect(() => {
    void loadPublicSettings().then(settings => setContact({
      email: settings.contactInfo.email,
      phone: settings.contactInfo.phone
    })).catch(loadError => setError(getSupabaseErrorMessage(loadError)));
  }, []);
  return <div className="min-h-screen bg-background py-12" data-id="element-674" data-mp="158lvxqzr4lt9">
      <div className="mx-auto max-w-4xl px-4" data-id="element-675" data-mp="1583orzbjwn6k">
        <header className="mb-12 text-center" data-id="element-676" data-mp="21qrvbjc2ddo7">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 text-primary" data-id="element-677" data-mp="21rjdnsgnhewj">
            <ShieldCheckIcon size={32} data-id="element-678" data-mp="1wxovwuklva03" />
          </span>
          <h1 className="mt-5 text-4xl font-display font-bold text-gray-900" data-id="element-679" data-mp="52c7v28w33r9">
            Politika privatnosti
          </h1>
          <p className="mt-3 text-xl text-gray-600" data-id="element-680" data-mp="9zch1m11cmml">
            Kako JumpLand prikuplja i štiti vaše podatke
          </p>
        </header>

        <article className="space-y-9 rounded-3xl border border-gray-100 bg-white p-7 text-gray-700 shadow-sm md:p-10" data-id="element-681" data-mp="9sti32do4le">
          <p className="rounded-2xl bg-primary/10 p-5 text-sm leading-6 text-gray-800" data-id="element-682" data-mp="3iew2hyvgt0r3">
            Ova politika objašnjava kako obrađujemo osobne podatke koje nam
            dostavljate prilikom slanja zahtjeva za termin ili kontakta s
            JumpLandom.
          </p>

          <PolicySection title="1. Koje podatke prikupljamo" data-id="element-683" data-mp="3dgb13w4h8b12">
            <p data-id="element-684" data-mp="3dix9fxz6yukc">
              Kada pošaljete zahtjev za termin, možemo prikupiti ime i prezime,
              broj telefona, email adresu ako je navedete, adresu događaja,
              željeni proizvod, datum i vrijeme najma, napomenu te fotografiju
              lokacije ako je dobrovoljno priložite.
            </p>
          </PolicySection>

          <PolicySection title="2. Zašto koristimo podatke" data-id="element-685" data-mp="158y3f4jn9893">
            <p data-id="element-686" data-mp="15bk90ymz5doo">
              Podatke koristimo isključivo za obradu vašeg zahtjeva, provjeru
              dostupnosti, kontakt u vezi najma, dostavu ili preuzimanje opreme
              te administraciju ugovorenih usluga. Slanje zahtjeva ne znači da
              je termin potvrđen; potvrdu daje JumpLand.
            </p>
          </PolicySection>

          <PolicySection title="3. Čuvanje i sigurnost" data-id="element-687" data-mp="1o0qo8bok7n5q">
            <p data-id="element-688" data-mp="1j8z3ihs34bni">
              Podaci o zahtjevima čuvaju se u zaštićenoj administraciji kojoj
              pristup imaju samo ovlaštene osobe. Fotografije lokacije nisu
              javno dostupne i koriste se samo za procjenu organizacije najma.
            </p>
          </PolicySection>

          <PolicySection title="4. Dijeljenje podataka" data-id="element-689" data-mp="2br4d5tbul5w3">
            <p data-id="element-690" data-mp="26xrv621obxcb">
              Vaše podatke ne prodajemo niti ih dijelimo u marketinške svrhe.
              Dijelimo ih samo kada je to potrebno za pružanje usluge ili kada
              to nalaže zakon.
            </p>
          </PolicySection>

          <PolicySection title="5. Kolačići i lokalna pohrana" data-id="element-691" data-mp="2gll0ptwz50l">
            <p data-id="element-692" data-mp="2fafakgwrn6u">
              Stranica trenutačno ne koristi kolačiće za oglašavanje ni
              praćenje posjetitelja. Administratorski dio koristi nužnu lokalnu
              pohranu preglednika za održavanje administratorske prijave.
            </p>
          </PolicySection>

          <PolicySection title="6. Vaša prava" data-id="element-693" data-mp="hckykfzslxd4">
            <p data-id="element-694" data-mp="m4ksnrt6lw1s">
              Možete zatražiti pristup, ispravak ili brisanje svojih osobnih
              podataka te ograničenje njihove obrade. Za zahtjev nam se javite
              putem kontakta navedenog u nastavku.
            </p>
          </PolicySection>

          <PolicySection title="7. Kontakt za privatnost" data-id="element-695" data-mp="v73x2gcm8gq5">
            {error ? <p role="alert" className="rounded-xl bg-red-50 p-4 text-red-800" data-id="element-696" data-mp="1055bgnz3jrva">
                {error}
              </p> : contact.email || contact.phone ? <ul className="space-y-2" data-id="element-697" data-mp="hjbwwo48aakq">
                {contact.email && <li data-id="element-698" data-mp="w76og16i28w8">
                    Email:{' '}
                    <a href={`mailto:${contact.email}`} className="font-bold text-primary underline-offset-4 hover:underline" data-id="element-699" data-mp="w6ol6klf6uet">
                      {contact.email}
                    </a>
                  </li>}
                {contact.phone && <li data-id="element-700" data-mp="3ur6mkg0fkwnl">Telefon: {contact.phone}</li>}
              </ul> : <p data-id="element-701" data-mp="di9uxzixfkf2">
                Kontakt podaci bit će dostupni uskoro. Za pitanja o privatnosti
                koristite stranicu Kontakt.
              </p>}
          </PolicySection>

          <p className="border-t border-gray-100 pt-6 text-sm text-gray-500" data-id="element-702" data-mp="1ouan7of01qzk">
            Zadnje ažuriranje: 23. srpnja 2026.
          </p>
        </article>
      </div>
    </div>;
}
function PolicySection({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <section data-id="element-703" data-mp="1wh7rak4osi4x">
      <h2 className="text-xl font-bold text-gray-900" data-id="element-704" data-mp="1wdjw7gjlfno3">{title}</h2>
      <div className="mt-3 leading-7" data-id="element-705" data-mp="1igwxb882ynfj">{children}</div>
    </section>;
}